import { ScheduleType } from '@src/models/interfaces/schedule.interface';
import { getRouteToEditCheckpoint } from '@src/packages/checkpointRoutes/constants';
import { getRouteToEventDrawer } from '@src/packages/events/constants';
import { getRouteToEditSchedule } from '@src/packages/schedules/constants';
import { getRouteToUserInfo } from '@src/packages/users/constants';
import { getFullUrl } from '@src/packages/utils';
import { getRouteToDetails } from '@src/packages/workOrders/constants';

import type { SearchEntry, SearchEntryDestination } from '../components/SidebarSearch/types';

const push = (path: string): SearchEntryDestination => ({ action: 'push', path });

/**
 * Where a sidebar search row goes. Schedule vs route uses the schedule's type,
 * so a checkpoint is never opened in the schedule editor.
 */
export const getSearchEntryRoute = (
  entry: SearchEntry,
  baseUrl: string,
): SearchEntryDestination | null => {
  if (entry.type === 'menu') {
    if (!entry.item.to) return null;
    if (entry.item.target === '_blank') return { action: 'blank', path: entry.item.to };
    return push(entry.item.to);
  }

  if (entry.type === 'user') {
    return push(getFullUrl(getRouteToUserInfo(entry.user.id), baseUrl));
  }

  if (entry.type === 'event') {
    return push(
      getFullUrl(getRouteToEventDrawer(entry.event.division.id, entry.event.id), baseUrl),
    );
  }

  if (entry.type === 'schedule' || entry.type === 'route') {
    const getRoute =
      entry.schedule.type === ScheduleType.CheckpointRoute
        ? getRouteToEditCheckpoint
        : getRouteToEditSchedule;
    return push(getFullUrl(getRoute(entry.schedule.divisionId, entry.schedule.id), baseUrl));
  }

  return push(getFullUrl(getRouteToDetails(entry.task.division.id, entry.task.id), baseUrl));
};
